import Component from 'vue-class-component'

Component.registerHooks([
  // for vue-router 2.2+
  'beforeRouteEnter',
  'beforeRouteLeave',
  'beforeRouteUpdate'
])
